export default __webpack_public_path__ + "static/media/232.b4a60465.jpg";